/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Complete_SubtitleInputs */

const en_onboarding_complete_subtitle = /** @type {(inputs: Onboarding_Complete_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nice work. Here's a quick summary:`)
};

const de_onboarding_complete_subtitle = /** @type {(inputs: Onboarding_Complete_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gute Arbeit. Hier eine kurze Zusammenfassung:`)
};

const fr_onboarding_complete_subtitle = /** @type {(inputs: Onboarding_Complete_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bon travail. Voici un résumé rapide :`)
};

const es_onboarding_complete_subtitle = /** @type {(inputs: Onboarding_Complete_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buen trabajo. Aquí tiene un resumen rápido:`)
};

const it_onboarding_complete_subtitle = /** @type {(inputs: Onboarding_Complete_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottimo lavoro. Ecco un riassunto veloce:`)
};

const nl_onboarding_complete_subtitle = /** @type {(inputs: Onboarding_Complete_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goed gedaan. Hier is een korte samenvatting:`)
};

const pl_onboarding_complete_subtitle = /** @type {(inputs: Onboarding_Complete_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobra robota. Oto szybki podsumowanie:`)
};

const fi_onboarding_complete_subtitle = /** @type {(inputs: Onboarding_Complete_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hienoa. Tässä on nopea yhteenveto:`)
};

const da_onboarding_complete_subtitle = /** @type {(inputs: Onboarding_Complete_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fint arbejde. Her er en hurtig opsummering:`)
};

const sv_onboarding_complete_subtitle = /** @type {(inputs: Onboarding_Complete_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bra jobbat. Här är en snabb sammanfattning:`)
};

/**
* | output |
* | --- |
* | "Nice work. Here's a quick summary:" |
*
* @param {Onboarding_Complete_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_complete_subtitle = /** @type {((inputs?: Onboarding_Complete_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Complete_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_complete_subtitle(inputs)
	if (locale === "fr") return fr_onboarding_complete_subtitle(inputs)
	if (locale === "es") return es_onboarding_complete_subtitle(inputs)
	if (locale === "it") return it_onboarding_complete_subtitle(inputs)
	if (locale === "nl") return nl_onboarding_complete_subtitle(inputs)
	if (locale === "pl") return pl_onboarding_complete_subtitle(inputs)
	if (locale === "fi") return fi_onboarding_complete_subtitle(inputs)
	if (locale === "da") return da_onboarding_complete_subtitle(inputs)
	if (locale === "sv") return sv_onboarding_complete_subtitle(inputs)
	return en_onboarding_complete_subtitle(inputs)
});